import React, { Component, useState } from "react";
import { Loading } from "../Loading";


export const Cel = ({ confirm, loading, msgBtn }) => {
  const [phoneNumber, setphoneNumber] = useState("");
  const [areaCode, setAreaCode] = useState("1");

  return (
    <div className="card-body">
      {/*   <label>Codigo</label> */}
      <div className="row align-items-center">
        <div className="col-5">
          <select
            className="form-control"
            style={{
              font: "droid sans mono, consolas, monospace",
            }}
            value={areaCode}
            onChange={(e) => setAreaCode(e.target.value)}
          >
            <option value="1">USA +1</option>
            <option value="52">MX +52</option>
          </select>
        </div>
        <div className="col-7">
          <input
            className="form-control"
            style={{
              font: "droid sans mono, consolas, monospace",
              letterSpacing: "0.5ch"
            }}
            type="tel"
            onChange={(e) => setphoneNumber(e.target.value)}
            inputMode="numeric"
            pattern="[0-9\s]{13,19}"
            maxLength={10}
            placeholder="xxx xxx xxxx"
          />
        </div>
      </div>
      <div className="row justify-content-end pt-3 mr-0">
        <button
          className="btn btn-primary"
          style={{ backgroundColor: "#203e60" }}
          disabled={phoneNumber.length < 10 || loading}
          onClick={() => confirm(areaCode + phoneNumber)}
        >
          {loading ? <Loading/> : msgBtn ? msgBtn :"Enviar Código"}
        </button>
      </div>
    </div>
  );
};
